import { machineTypeSchema } from "@packsize/schemas/machines";

export const X5_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.X5 }] as const;
